import { render, staticRenderFns } from "./lazyblock_this_month.vue?vue&type=template&id=8c31a838&scoped=true"
import script from "./lazyblock_this_month.vue?vue&type=script&lang=js"
export * from "./lazyblock_this_month.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_this_month.vue?vue&type=style&index=0&id=8c31a838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c31a838",
  null
  
)

export default component.exports